/* eslint-disable jsx-a11y/alt-text */
import React, { Component, Fragment } from 'react';
import { shopContext } from '../../contexts/aniplus';
import { withRouter } from 'react-router-dom';
import axios from 'axios';

import StarCommentItem from '../../components/StarCommentItem';
import SumSex from './SumSex';
import SumAge from './SumAge';
import SumStar from './SumStar';
//import ReactStars from "react-rating-stars-component";
import { toast } from 'react-toastify'; //토스트(toast)
// import { confirmAlert } from "react-confirm-alert"; //알럿창(alert confirm)
import { isMobile, isAndroid, isIOS } from 'react-device-detect';

class StarComment extends Component {
  state = {
    gotoPage: 1,
    pageCount: 1,
    con: 0,
    comment: '',
    starOn: false,
    star: 0,
    starWidth: 0,
    starValue: 0,
  };
  mouseDown = false;
  _isMounted = false;
  componentDidMount = () => {
    this._isMounted = true;
    const { contentSerial } = this.props.childProps;
    this._getData(1, contentSerial);
  };
  componentWillUnmount = () => {
    this._isMounted = false;
  };
  UNSAFE_componentWillReceiveProps = (nextProps, nextState) => {
    //console.log(this.props.location.pathname)
    //console.log(nextProps.location)
    return (
      this.props.childProps.contentSerial !== nextProps.childProps.contentSerial
    );
    //return true;
  };
  componentWillReceiveProps = (nextProps) => {
    ////console.log(nextProps)
    //console.log(this.props.childProps.contentSerial, nextProps.childProps.contentSerial)

    if (
      this.props.childProps.contentSerial !== nextProps.childProps.contentSerial
    ) {
      this._getData(1, nextProps.childProps.contentSerial);
    }
  };
  _getData = async (gotoPage, contentSerial) => {
    const { onCommentCount } = this.props.childProps;

    if (
      contentSerial === '' ||
      contentSerial === null ||
      contentSerial === undefined
    ) {
      alert('잘못된 경로 또는 URL입니다.');
    } else {
      const result = await this._getDataApi(gotoPage, contentSerial);
      const con = result.data[0].con;
      const pageCount = result.data[0].pageCount;
      const intReturn = result.data[0].intReturn;
      const commentList = result.data[0].listData;

      //console.log(gotoPage, pageCount, con)

      if (intReturn === 0) {
        if (this._isMounted) {
          this.setState({
            commentList,
            con,
            pageCount,
            gotoPage,
          });
          onCommentCount(con);
        }
      }
    }
  };

  _getDataApi = (gotoPage, contentSerial) => {
    const { apiUrl } = this.props;
    //const { contentSerial } = this.props.childProps;
    ////console.log(apiUrl + '/itemInfo?contentSerial=' + contentSerial)

    return axios(
      apiUrl +
        '/starComment?contentSerial=' +
        contentSerial +
        '&gotoPage=' +
        gotoPage
    )
      .then((response) => response)
      .catch((error) => {
        // alert("오류가 발생했습니다.");
      });
  };
  _renderItem = () => {
    const { commentList } = this.state;

    const list = commentList.map((item, index) => {
      return (
        <StarCommentItem
          key={index}
          RowNum={item.RowNum}
          idx={item.idx}
          userid={item.userid}
          nicName={item.nicName}
          charac_img={item.charac_img}
          content={item.content}
          regDate={item.regDate}
          contentValue={item.contentValue}
          onDel={this._onDel}
        />
      );
    });

    return list;
  };
  _renderPage = () => {
    const { pageCount, gotoPage, con } = this.state;
    const { contentSerial } = this.props.childProps;
    const dataPerPage = isMobile ? 5 : 10; //한페이지에 보여질 레코드 갯수

    const pageNumbers = [];

    const totalPage = Math.ceil(con / dataPerPage); //총페이지수

    let pageCount1;

    if (pageCount > dataPerPage) {
      pageCount1 = dataPerPage;
    } else {
      pageCount1 = pageCount;
    }

    const pageGroup = Math.ceil(gotoPage / pageCount1); //페이지 그룹
    let last = pageGroup * pageCount1;

    if (last > totalPage) {
      last = totalPage;
    }

    let first = last - (pageCount1 - 1); //화면에 보여질 첫번째 페이지 번호

    const next = last + 1;
    // const prev = first - 1;

    if (totalPage < 1) {
      first = last;
    }

    if (first > pageCount1) {
    } else {
    }

    if (next > pageCount1 && next < totalPage) {
    } else {
    }

    for (let j = first; j <= last; j++) {
      pageNumbers.push(j);
    }

    const list = pageNumbers.map((num, index) => {
      return (
        <span
          key={index}
          style={{ cursor: 'pointer' }}
          onClick={() => this._getData(num, contentSerial)}
          className={gotoPage === num ? 'on' : null}
        >
          {num}
        </span>
        /*<a href="#" className={gotoPage === num ? "active" : null } onClick={()=>this._page(num)} key={index}>{num}</a>*/
      );
    });

    return (
      <Fragment>
        {first > pageCount1 ? (
          <span onClick={this._onPrev}>이전</span>
        ) : (
          <span style={{ backgroundColor: 'transparent' }}></span>
        )}
        {list}
        {next > pageCount1 && next < totalPage ? (
          <span onClick={this._onNext}>다음</span>
        ) : (
          <span style={{ backgroundColor: 'transparent' }}></span>
        )}
      </Fragment>
    );
  };
  _onPrev = () => {
    const { gotoPage } = this.state;
    const { contentSerial } = this.props.childProps;
    if (gotoPage === 1) {
      //alert('페이지의 처음입니다.')
      toast.warn('페이지의 처음입니다.');
    } else {
      this._getData(gotoPage - 1, contentSerial);
    }
  };
  _onNext = () => {
    const { pageCount, gotoPage } = this.state;
    const { contentSerial } = this.props.childProps;

    if (gotoPage + 1 >= pageCount) {
      toast.warn('페이지의 마지막입니다.');
      //alert('페이지의 마지막입니다.')
    } else {
      this._getData(gotoPage + 1, contentSerial);
    }
  };
  _onCommentChange = (e) => {
    const { loginId } = this.props;
    if (loginId === null || loginId === undefined || loginId === '') {
      toast.warn('로그인 후 글을 남기실 수 있습니다.');
      //alert('로그인 후 글을 남기실 수 있습니다.')
    } else {
      this.setState({
        comment: e.target.value,
      });
    }
  };
  _onReg = async () => {
    const { loginId } = this.props;
    const { comment, starValue } = this.state;
    const { contentSerial } = this.props.childProps;
    //console.log(comment, starValue)

    if (loginId === null || loginId === undefined || loginId === '') {
      toast.warn('로그인 후 이용하실 수 있습니다.');
    } else {
      if (comment === '' || comment === null || comment === undefined) {
        toast.warn('감상평을 입력해 주세요');
        return false;
      }
      if (
        starValue === '' ||
        starValue === null ||
        starValue === undefined ||
        starValue === 0
      ) {
        toast.warn('평가 별점을 입력해 주세요.');
        return false;
      }

      const result = await this._onRegApi();
      if (result) {
        const intReturn = result.data[0].intReturn;
        //console.log(intReturn)
        if (intReturn === 0) {
          this._getData(1, contentSerial);
          this.setState({
            comment: '',
          });
        } else {
          toast.error('등록중 오류가 발생했습니다.');
          //alert('오류가 발생했습니다.')
        }
      }
    }
  };
  _onRegApi = () => {
    const { apiUrl, loginId, authId, history } = this.props;
    // const at = localStorage.getItem('at');
    const at = this.getCookie('at');
    const { contentSerial } = this.props.childProps;
    const { comment, starValue } = this.state;
    //const contentValue = 10

    return axios
      .post(
        apiUrl + '/starCommentAdd',
        {
          params: {
            userid: loginId,
            authId: authId,
            contentSerial: contentSerial,
            content: comment,
            contentValue: starValue,
          },
        },
        {
          headers: {
            Authorization: 'bearer ' + at,
          },
        }
      )
      .then((response) => response)
      .catch((error) => {
        //toast.error('오류가 발생했습니다.')
        if (error.response.status === 403) {
          //console.log('refresh....token...')
          this._refreshToken('add', 0);
        } else if (error.response.status === 400) {
          history.push('/login');
        }
      });
  };
  _refreshToken = async (gubun, idx) => {
    const { history, apiUrl, setLoginId, setAuthId, loginId } = this.props;
    // const rt = localStorage.getItem('rt');
    const rt = this.getCookie('rt');
    if (rt === '' || rt === undefined || rt === null) {
      history.push('/login');
      return false;
    }

    const { data } = await axios.post(apiUrl + '/refreshToken', {
      params: {
        rt: rt,
        userid: loginId,
      },
    });

    if (data[0].intReturn === 0) {
      //console.log(data[0].at)
      localStorage.setItem('at', data[0].at);
      if (gubun === 'add') {
        this._onReg();
      } else if (gubun === 'del') {
        this._onDel(idx);
      }
    } else {
      this.setCookie('account', '');

      setLoginId('');
      setAuthId('');

      setTimeout(() => {
        history.push('/login');
      }, 500);
    }
  };
  setCookie = (name, value, exp) => {
    let expires;
    if (exp) {
      var date = new Date();
      date.setTime(date.getTime() + exp * 24 * 60 * 60 * 1000);
      expires = date.toGMTString();
    } else {
      expires = '';
    }
    document.cookie =
      name +
      '=' +
      value +
      ';expires=' +
      expires +
      ';path=/; SameSite=None; Secure; domain=aniplustv.com';
  };
  _onDel = async (idx) => {
    const { loginId } = this.props;
    const { contentSerial } = this.props.childProps;

    if (loginId === null || loginId === undefined || loginId === '') {
    } else {
      if (idx === '' || idx === null || idx === undefined) {
      } else {
        const result = await this._onDelApi(idx);
        if (result) {
          const intReturn = result.data[0].intReturn;
          //console.log(intReturn)
          if (intReturn === 0) {
            this._getData(1, contentSerial);
          } else {
            toast.error('오류가 발생했습니다.');
          }
        }
      }
    }
  };
  getCookie = (name) => {
    var value = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');

    return value ? value[2] : null;
  };
  _onDelApi = (idx) => {
    const { apiUrl, loginId, authId, history } = this.props;
    const at = this.getCookie('at');
    // const at = localStorage.getItem('at');
    //console.log(idx)

    return axios
      .post(
        apiUrl + '/starCommentDel',
        {
          params: {
            userid: loginId,
            authId: authId,
            idx: idx,
          },
        },
        {
          headers: {
            Authorization: 'bearer ' + at,
          },
        }
      )
      .then((response) => response)
      .catch((error) => {
        //toast.error('오류가 발생했습니다.')
        if (error.response.status === 403) {
          //console.log('refresh....token...')
          this._refreshToken('del', idx);
        } else if (error.response.status === 400) {
          history.push('/login');
        }
      });
  };
  _onToggleStar = () => {
    const { starOn } = this.state;

    this.setState({
      starOn: !starOn,
    });
  };
  ratingChanged = (newRating) => {
    //console.log(newRating);
  };
  _startEvent = (e) => {
    //alert(0)
    // const width =
    //   document.getElementsByClassName("star_img_bg1")[0].offsetWidth;
    const posx = document
      .getElementsByClassName('star_img_bg1')[0]
      .getBoundingClientRect().left;
    e.preventDefault();

    if (e.type === 'mousedown') {
      this.mouseDown = true;
      let star = ((e.clientX - posx) / 219) * 10;

      if (star >= 9.9) {
        star = 10;
      } else if (star < 0) {
        star = 0;
      } else {
        star = star.toFixed(1);
      }

      //console.log(star)

      let starWidth = ((e.clientX - posx) / 219) * 100;
      let starValue = star;

      this.setState({
        star,
        starWidth,
        starValue,
      });
      ////console.log('mousedown')
    } else if (e.type === 'mouseup') {
      this.mouseDown = false;
      ////console.log('mouseup')
    } else if (e.type === 'mousemove') {
      ////console.log(e.clientX)
      let star = ((e.clientX - posx) / 219) * 10;
      //console.log(star)
      if (star >= 9.9) {
        star = 10;
      } else if (star < 0) {
        star = 0;
      } else {
        star = star.toFixed(1);
      }
      let starWidth = ((e.clientX - posx) / 219) * 100;
      let starValue = star;

      if (this.mouseDown) {
        ////console.log(e.clientX, width, posx)
        //const (event.clientX/width)
        /*
                if(e.clientX > 280 && e.clientX <=324) {
                    starValue = 2.0
                } else if (e.clientX > 325 && e.clientX <=369) {
                    starValue = 4.0
                } else if (e.clientX > 367 && e.clientX <=411) {
                    starValue = 5.0
                } else if (e.clientX > 412 && e.clientX <=456) {
                    starValue = 6.0     
                } else if (e.clientX > 457 && e.clientX <=500) {
                    starValue = 10.0
                }
                */
        ////console.log(star)
        this.setState({
          star,
          starWidth,
          starValue,
        });
      }
    }
  };
  render() {
    const { commentList, pageCount, comment, con, starOn, star, starWidth } =
      this.state;
    const { contentSerial } = this.props.childProps;
    const { imgUrl } = this.props;
    return (
      <Fragment>
        <div className="detil_group4">
          <h1>
            작품평가.<span>{con ? '총' + con + '개' : null}</span>
          </h1>
          <div className="libyu_textarea">
            {starOn ? (
              <div className="star_img_group2">
                <div
                  className="star_img_bg1"
                  onMouseDown={this._startEvent}
                  onMouseUp={this._startEvent}
                  onMouseMove={this._startEvent}
                >
                  {/*
                                    <ReactStars
                                        className="star_img_bg1"
                                        count={5}
                                        onChange={this.ratingChanged}
                                        size={24}
                                        isHalf={true}
                                        emptyIcon={<i className="far fa-star"></i>}
                                        halfIcon={<i className="fa fa-star-half-alt"></i>}
                                        fullIcon={<i className="fa fa-star"></i>}
                                        activeColor="#fa642f "
                                    />
                                    */}
                  <div
                    className="star_img_bg1_on"
                    style={{ width: starWidth + '%' }}
                  ></div>
                </div>
                <em>
                  <strong>{star}</strong>나의별점
                </em>
              </div>
            ) : (
              <div className="star_img_group" onClick={this._onToggleStar}>
                <img src={imgUrl + '/img/detail_img/star_img2.png'} />

                <em>나의별점</em>
              </div>
            )}

            <div className={starOn ? 'star_img_group_padding' : null}>
              <textarea
                name=""
                cols=""
                rows=""
                value={comment}
                onChange={this._onCommentChange}
                className="common_input libyu_input"
                placeholder="감상평을 작성해 주세요"
              ></textarea>
            </div>
            <span style={{ cursor: 'pointer' }} onClick={this._onReg}>
              <em>등록</em>
            </span>
          </div>

          <div className="libyu_graph">
            <div className="float_left">
              <SumStar contentSerial={contentSerial} />
              {/*
                            <div className="width_auto">
                                <div className="left_float_left">
                                    4.5
                                    <div className="star_img3"><div className="star_img3_on" style={{width:'50%'}}></div></div>
                                    <span>(345개의 평가)</span>
                                </div>
                                
                                <div className="left_float_right">
                                    <ul>
                                        <li><span>5</span><p className="on" style={{width:'100%'}}></p></li>
                                        <li><span>4</span><p className="" style={{width:'10%'}}></p></li>
                                        <li><span>3</span><p className="" style={{width:'30%'}}></p></li>
                                        <li><span>2</span><p className="" style={{width:'20%'}}></p></li>
                                        <li><span>1</span><p className="" style={{width:'60%'}}></p></li>
                                    </ul>
                                </div>
                            </div>
                            */}
            </div>

            <div className="float_right">
              <div className="width_auto">
                <h2>
                  성별·나이별 <br />
                  관람추이
                </h2>
                <dl>
                  <SumSex contentSerial={contentSerial} />
                  <SumAge contentSerial={contentSerial} />
                  {/*
                                    <dt>
                                        <div><span style={{height: '50%'}}></span><em>남자</em></div>
                                        <div><span style={{height: '80%'}}></span><em>여자</em></div>
                                    </dt>
                                    <dd>
                                        <div style={{height: '28%'}}>
                                            <em>28%</em>
                                            <p>10대</p>
                                        </div>
                                        <div className="on" style={{height: '80%'}}>
                                            <em>80%</em>
                                            <p>20대</p>
                                        </div>
                                        <div style={{height: '28%'}}>
                                            <em>28%</em>
                                            <p>30대</p>
                                        </div>
                                        <div style={{height: '28%'}}>
                                            <em>28%</em>
                                            <p>40대</p>
                                        </div>
                                        <div style={{height: '28%'}}>
                                            <em>28%</em>
                                            <p>50대↑</p>
                                        </div>
                                    </dd>
                                    */}
                </dl>
              </div>
            </div>
          </div>

          {commentList ? (
            <div className="libyu_group">
              <div className="libyu_list">{this._renderItem()}</div>
              <div className="page_no">{this._renderPage()}</div>
            </div>
          ) : null}
        </div>
      </Fragment>
    );
  }
}

export default shopContext(withRouter(StarComment));
